module.exports = __webpack_public_path__ + "5bf54f9e071e5fab8491c37f83fe7361.png";